"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultShareState = void 0;
exports.defaultShareState = {
    title: 'Like it? Share with others!',
    url: 'https://www.okay.com',
    isActive: false,
    nameCopy: 'Copy link'
};
